import baseAPI from "@/api/base";
import {
  EditOpportunityContact,
  GetOpportunityContact,
  RegisterOpportunityContact,
} from "@/dtos/OpportunityContact.dto";
import {
  DELETE_OPPORTUNITY_CONTACT_URL,
  EDIT_OPPORTUNITY_CONTACT_URL,
  GET_OPPORTUNITY_CONTACT_URL,
  REGISTER_OPPORTUNITY_CONTACT_URL,
  TOGGLE_OPPORTUNITY_CONTACT_IS_ACTIVE_URL,
} from "@/utils/urls";
import { AxiosResponse } from "axios";

class OpportunityContact {
  static getOpportunityContacts = async (
    getOpportunityContact: GetOpportunityContact
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_OPPORTUNITY_CONTACT_URL, {
      params: getOpportunityContact,
    });
    return response;
  };

  static registerOpportunityContact = async (
    registerOpportunityContact: RegisterOpportunityContact
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(REGISTER_OPPORTUNITY_CONTACT_URL, {
      ...registerOpportunityContact,
    });
    return response;
  };

  static editOpportunityContact = async (
    editOpportunityContact: EditOpportunityContact
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.put(EDIT_OPPORTUNITY_CONTACT_URL, {
      ...editOpportunityContact,
    });
    return response;
  };

  static toggleOpportunityContactIsActive = async (
    editOpportunityContact: EditOpportunityContact
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.patch(TOGGLE_OPPORTUNITY_CONTACT_IS_ACTIVE_URL, {
      ...editOpportunityContact,
    });
    return response;
  };

  static deleteOpportunityContact = async (id: string): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.delete(`${DELETE_OPPORTUNITY_CONTACT_URL}/${id}`);
    return response;
  };
}

export default OpportunityContact;
